import { AxiosError, AxiosResponse } from 'axios';
import useSWR, { mutate } from 'swr';

import { ApiModuleVersionMap } from '../../content/models/ApiModuleVersionMap';
import Config from '../config';

export function useModuleVersionMaps(modulekey: number, moduleVersion: number) {
  const url =
    modulekey && moduleVersion
      ? `${Config.API}/api/component/list/map/module/${modulekey}/version/${moduleVersion}/component`
      : undefined;
  const { data: response, error } = useSWR<
    AxiosResponse<ApiModuleVersionMap[]>,
    AxiosError<Error>
  >(url);

  function update() {
    mutate(url);
  }

  return {
    loading: !response,
    error: !!error,
    data: response?.data,
    update
  };
}
